import React, { useState, useEffect, useCallback, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import SearchTypeahead from "web/components/SearchTypeahead";
import Pagination from "web/components/Pagination";
import { BIDFORMAT } from "web/components/utils/dateOfBirthValidation";
import * as moment from "moment";
import styled from "styled-components";
import { orderHoldPayment } from "redux/actions/payment";
import { useDispatch, useSelector } from "react-redux";
import DropDown from "web/components/DropDown";
import AlertModal from "web/components/AlertModal";
import Breadcrumb from "web/components/Breadcrumb";
import { orderBagageInfo, orderBagageUpdate } from "redux/actions/notification";
import { sortByListValues, breadcrumbMapArr } from "../Constants"
import { orderUpdate, downloadOrderById, canceledOrder, canceledOrderListing, allOrderListing, claimedOrderListing, claimDispute, listAllPendingRequestsOrders, listAllOpenOrders, completedOrders, listAllDeliveredStatus, ratingUpdate, acceptAndReject, repostAndScheduledOrder, cancelSellerBuyerOrder, retryOrderPayment, } from "redux/actions/myOrders";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import OrderBox from "../OrderTabs/OrderBox";
import FilterIcon from "web/assets/images/filterIcon.png";
import FilterModal from "./FilterModal";
import { Container, SearchSection, OrderTopHeader, SectionWrapper, OrderTabDescription, FilterWrapper } from "./orderTabsStyled";
import { fetchLanguageContentNew } from "redux/actions/language";
import { downloadFile } from "redux/actions/helper/downloadFile";
import DeliveryRequestsListDetails from "./DeliveryRequestsListDetails";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "transparent",
  },
  indicator: {
    background: "#2fb5f1",
  },

  AppBar: {
    backgroundColor: "transparent",
    color: "#000000",
    boxShadow: "none",
  },
  Tab: {
    textTransform: "capitalize",
    fontSize: "16px",
  },
  hiddenTab: {
    display: 'none',
  },
}));

export default function SimpleTabs({ urlSearchParams }) {
  let history = useHistory();
  const storedData = useSelector((state) => state.storedData.payload);
  const dispatch = useDispatch();
  const location = useLocation();
  const typeahead = useRef(null);
  const classes = useStyles();
  const [filterPopUpModal, setFilterPopUpModal] = useState(false);
  const token = localStorage.getItem("token");

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  const selectedPageObj = useSelector((state) => state.urlParameters.myOrderSelectedPage);

  let selectedPageNo = 1
  if (selectedPageObj?.myOrderSelectedPage) selectedPageNo = selectedPageObj?.myOrderSelectedPage

  const [value, setValue] = useState(0)
  const [currentPage, setCurrentPage] = useState(selectedPageNo);
  const [displayHoldBanner, setDisplayHoldBanner] = useState(true)
  const displayHoldBannerFunc = (value) => setDisplayHoldBanner(value)

  const [searchVal, setSarchVal] = useState(localStorage.getItem('redirectedOrderValue') || '');
  const [orderPageData, setOrderPageData] = useState(undefined);
  const [orderCount, setOrderCount] = useState();
  const [deliveryTenderRequestsData, setDeliveryTenderRequestsData] = useState(undefined);

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();
  const [sortByValue, setSortByValue] = useState("ASC");

  let defaultFilterModalValues = {
    bidStatus: 'PENDING',
    deliveryReq: 'ALL',
    fromDateOrderFilter: moment().subtract(31, 'days').format('YYYY-MM-DD'),
    toDateOrderFilter: moment().add(31, 'days').format('YYYY-MM-DD')
  };
  const [filterModalValues, setFilterModalValues] = useState(defaultFilterModalValues)

  const orderTabsList = [
    { label: 'Pending Delivery Requests', type: 'PENDING_DELIVERY', count: 0, sortOrder: 'ASC' },
    { label: 'Pending Orders', type: 'OPEN', count: orderCount?.openOrderCount, sortOrder: 'ASC' },
    { label: 'Delivered Orders', type: 'DELIVERED', count: orderCount?.deliveredOrderCount, sortOrder: 'ASC' },
    { label: 'Completed Orders', type: 'COMPLETE', count: orderCount?.commpleteOrderCount, sortOrder: 'ASC' },
    { label: 'Canceled Orders', type: 'CANCELLED', count: orderCount?.cancelledOrderCount, sortOrder: 'ASC' },
    { label: 'Claimed Orders', type: 'CLAIMED', count: orderCount?.claimedOrderCount, sortOrder: 'ASC' },
    { label: 'All Orders', type: 'ALL', count: orderCount?.totalCount, sortOrder: 'DESC' },
  ];

  const handleTabClick = (type, index, sortOrder) => {
    setSortByValue(sortOrder);
    if (type !== 'ALL' && type !== 'PENDING_DELIVERY') orderBagageUpdateApi(type);
    setOrderPageData(undefined);
    setValue(index);
    let filterModalValuesTemp = defaultFilterModalValues
    if (type === 'ALL' || type === 'OPEN') filterModalValuesTemp = { ...defaultFilterModalValues, bidStatus: 'ALL' }
    setFilterModalValues(filterModalValuesTemp);
    orderBagageInfoApi();

    dispatch({ type: 'MYORDER_PAGINATION', payload: { myOrderSelectedPage: 1 } });
    setCurrentPage(1);
    setSarchVal('');

    // Choose the appropriate API call based on the order type
    const apiCalls = {
      PENDING_DELIVERY: () => pendingDeliveryRequestsApi(sortOrder, '', 1, filterModalValuesTemp),
      OPEN: () => openOrderApi(sortOrder, '', 1, filterModalValuesTemp),
      DELIVERED: () => deliveredOrderApi(sortOrder, '', 1, filterModalValuesTemp),
      COMPLETE: () => completedOrdersApi(sortOrder, '', 1, filterModalValuesTemp),
      CANCELLED: () => canceledOrderListingApi(sortOrder, '', 1, filterModalValuesTemp),
      CLAIMED: () => claimedOrderListingApi(sortOrder, '', 1, filterModalValuesTemp),
      ALL: () => allOrderListingApi(sortOrder, '', 1, filterModalValuesTemp),
    };

    apiCalls[type]();
    if (type === 'OPEN') setDisplayHoldBanner(true);
  };

  useEffect(() => {
    if (languageContentNew?.My_Orders_Page) setPageLanguageContents(languageContentNew.My_Orders_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  useEffect(() => {
    const localStoredTabValue = parseInt(localStorage.getItem('manageOrderTabFromPtPlusScheduledPost'));
    const redirectedsSearchByOrderValue = localStorage.getItem('redirectedOrderValue');
    const queryParams = new URLSearchParams(location.search);
    const hideFirstTab = !storedData?.data?.isDeliveryPricingVendor;
    const selectedTab = urlSearchParams.selectedTab;

    let tabValueTemp;

    if (queryParams.get("tab") === 'all-order') tabValueTemp = 6
    else if (selectedTab === "DELIVERED") tabValueTemp = 2
    else if (selectedTab === "CANCELLED") tabValueTemp = 4
    else if (selectedTab === "PENDING" || queryParams.get("ordertab") === 'pending_orders') tabValueTemp = 1
    else tabValueTemp = localStoredTabValue || (hideFirstTab ? 1 : 0)

    const fetchOrderData = (tabValue, sortValueTemp, filterModalValuesTemp) => {
      const apiMapping = { 0: pendingDeliveryRequestsApi, 1: openOrderApi, 2: deliveredOrderApi, 3: completedOrdersApi, 4: canceledOrderListingApi, 5: claimedOrderListingApi, 6: allOrderListingApi, };
      const apiFunc = apiMapping[tabValue];
      let searchByValue = searchVal
      if (redirectedsSearchByOrderValue) {
        searchByValue = redirectedsSearchByOrderValue
        setSarchVal(searchByValue)
      }
      if (apiFunc) {
        setOrderPageData(undefined);
        apiFunc(sortValueTemp, searchByValue, 1, filterModalValuesTemp);
      }
    };

    let sortValueTemp = tabValueTemp === 6 ? 'DESC' : sortByValue;
    let filterModalValuesTemp = { ...defaultFilterModalValues };

    filterModalValuesTemp.bidStatus =
      tabValueTemp === 0 ? 'PENDING' :
        tabValueTemp === 1 || tabValueTemp === 6 ? 'ALL' :
          tabValueTemp === 2 ? 'DELIVERED' :
            tabValueTemp === 3 ? 'COMPLETE' :
              tabValueTemp === 4 ? 'CANCELLED' :
                tabValueTemp === 5 ? 'CLAIM' : null;

    setSortByValue(sortValueTemp);
    setFilterModalValues(filterModalValuesTemp);
    setValue(tabValueTemp);
    fetchOrderData(tabValueTemp, sortValueTemp, filterModalValuesTemp);

    localStorage.removeItem('manageOrderTabFromPtPlusScheduledPost');
    localStorage.removeItem('redirectedOrderValue');
    dispatch({ type: 'ORDERS', payload: {} });
  }, []);

  const pendingDeliveryRequestsApi = async (sortVal, searchVal, pageNo, filterValues) => {
    let data = {
      authId: localStorage.getItem('authId'),
      locationId: localStorage.getItem('locationID'),
      size: 10,
      number: pageNo - 1 || 0,
      sort: sortVal,
      currentOrderTab: null,
      searchCriteria: {
        searchBy: searchVal,
        fromDate: searchVal?.trim() ? null : moment(filterValues.fromDateOrderFilter).format('YYYY/MM/DD'),
        toDate: searchVal?.trim() ? null : moment(filterValues.toDateOrderFilter).format('YYYY/MM/DD'),
        orderStatus: ["PENDING"]
      }
    }
    let deliveryRequestsResponse = await dispatch(listAllPendingRequestsOrders(data, token))
    if (deliveryRequestsResponse?.success) {
      setDeliveryTenderRequestsData([])
      setDeliveryTenderRequestsData(JSON.parse(JSON.stringify(deliveryRequestsResponse?.data)))
      setOrderPageData()
    } else {
      if (deliveryRequestsResponse.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(deliveryRequestsResponse?.data?.error?.message || deliveryRequestsResponse?.data?.message || deliveryRequestsResponse?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  }

  const openOrderApi = async (sortVal, searchId, pageNo, filterValues) => {
    let response = await dispatch(listAllOpenOrders(sortVal, token, searchId, pageNo, filterValues));
    if (response.status === "SUCCESS") {
      setOrderPageData(response.payload);
      setDeliveryTenderRequestsData()
      orderBagageInfoApi();
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        if (searchId === "" || searchId === undefined) {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const deliveredOrderApi = async (sortByValue, searchId, pageNo, filterValues) => {
    let response = "";
    response = await dispatch(listAllDeliveredStatus(sortByValue, token, searchId, pageNo, filterValues));

    if (response.status === "SUCCESS") {
      setOrderPageData(response.payload);
      setDeliveryTenderRequestsData()
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        if (searchId === "" || searchId === undefined) {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const completedOrdersApi = async (sortVal, searchId, pageNo, filterValues) => {
    let response = "";
    response = await dispatch(completedOrders(sortVal, token, searchId, pageNo, filterValues));
    if (response.status === "SUCCESS") {
      setOrderPageData(response.payload);
      setDeliveryTenderRequestsData()
      orderBagageInfoApi();
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        if (searchId === "" || searchId === undefined) {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const canceledOrderListingApi = async (sortVal, searchId, pageNo, filterValues) => {
    let response = await dispatch(canceledOrderListing(sortVal, token, searchId, pageNo, filterValues));
    if (response.status === "SUCCESS") {
      if (response.payload.length !== 0) {
        setOrderPageData(response.payload);
        setDeliveryTenderRequestsData()
      }
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        if (searchId === "" || searchId === undefined) {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const claimedOrderListingApi = async (sortVal, searchId, pageNo, filterValues) => {
    let response = await dispatch(claimedOrderListing(sortVal, token, searchId, pageNo, filterValues));
    if (response.status === "SUCCESS") {
      if (response.payload.length !== 0) {
        setOrderPageData(response.payload);
        setDeliveryTenderRequestsData()
      }
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        if (searchId === "" || searchId === undefined) {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const allOrderListingApi = async (sortVal, searchId, pageNo, filterValues) => {
    let response = await dispatch(allOrderListing(sortVal, token, searchId, pageNo, filterValues));
    if (response.status === "SUCCESS") {
      if (response.payload.length !== 0) {
        setOrderPageData(response.payload);
        setDeliveryTenderRequestsData()
      }
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        if (searchId === "" || searchId === undefined) {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const onPageChange = (pageNumber) => {
    setOrderPageData(undefined);
    setCurrentPage(pageNumber);
    if (value === 0) pendingDeliveryRequestsApi(sortByValue, searchVal, pageNumber, filterModalValues);
    if (value === 1) openOrderApi(sortByValue, searchVal, pageNumber, filterModalValues);
    if (value === 2) deliveredOrderApi(sortByValue, searchVal, pageNumber, filterModalValues);
    if (value === 3) completedOrdersApi(sortByValue, searchVal, pageNumber, filterModalValues);
    if (value === 4) canceledOrderListingApi(sortByValue, searchVal, pageNumber, filterModalValues);
    if (value === 5) claimedOrderListingApi(sortByValue, searchVal, pageNumber, filterModalValues);
    if (value === 6) allOrderListingApi(sortByValue, searchVal, pageNumber, filterModalValues);
  };

  const orderBagageInfoApi = async () => {
    let response = await dispatch(orderBagageInfo(token));
    if (response.status === "SUCCESS") {
      setOrderCount(JSON.parse(JSON.stringify(response.payload)));
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  };

  const callUpdateStatus = async (id, status, values, fromTabType) => {
    let data;
    let formData = new FormData();
    let response;
    if (status === "DELIVERED") {
      data = {
        orderId: id,
        shippingStatus: status,
        urlBill: ["url1", "url2"],
        fromDate: values.orderDeliveryDate,
        fromTime: values.orderDeliveryTime,
        requestFromPtplusUser: false
      };
      formData.append("request", JSON.stringify(data));
      formData.append("file", values.bolDocument);
      response = await dispatch(orderUpdate(formData, token));
    } else {
      data = {
        orderId: id,
        shippingStatus: status,
        requestFromPtplusUser: false
      };
      formData.append("request", JSON.stringify(data));
      response = await dispatch(orderUpdate(formData, token));
    }

    if (response.status === "SUCCESS") {
      if (status === "DELIVERED") {
        handleTabClick('DELIVERED', 2, 'ASC')
      } else {
        if (fromTabType === 'fromAllOrdersTab') handleTabClick('OPEN', 1, 'ASC')
        else {
          setValue(1);
          setOrderPageData(undefined);
          openOrderApi(sortByValue, searchVal, currentPage, filterModalValues);
        }
      }
      setModalContent(response.message);
      setModalLink("");
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  };

  const retryPayment = async (id) => {
    let response = await dispatch(retryOrderPayment(id, token));
    if (response.status === "SUCCESS") {
      setValue(2);
      setOrderPageData(undefined);
      deliveredOrderApi(sortByValue, searchVal, currentPage, filterModalValues);
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  };

  const imageUploadApi = async (imagePath) => {
    dispatch(downloadFile(imagePath));
  };

  const downloadOrderApi = async (id) => {
    let response = await dispatch(downloadOrderById(id, token));
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Download Receipt.pdf");
    document.body.appendChild(link);
    link.click();
  };

  const canceledOrderApi = async (id) => {
    let data = { orderId: id };
    let response = await dispatch(canceledOrder(data, token));
    if (response.status === "SUCCESS") {
      setValue(4);
      setOrderPageData(undefined);
      canceledOrderListingApi(sortByValue, searchVal, currentPage, filterModalValues);
      setModalContent(response.message);
      setModalLink("");
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  };

  const handleTabChangeFunction = (event, newValue) => {
    setValue(newValue);
  };

  const callDisputeApi = async (id) => {
    let data = { orderId: id, };
    let response = await dispatch(claimDispute(data, token));
    if (response.status === "SUCCESS") {
      setValue(2);
      setOrderPageData(undefined);
      deliveredOrderApi(sortByValue, searchVal, currentPage, filterModalValues);

      setModalContent(response.message);
      setModalLink("");
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  };

  const ratingUpdateCompletedAPI = async (items, ratingValue, comment, tabType) => {
    let data = {
      orderId: items.id,
      rating: ratingValue,
      review: comment,
      userType: items.userType,
    };
    let response = await dispatch(ratingUpdate(data, token));
    if (response.status === "SUCCESS") {
      setModalContent(response.message);
      setModalLink("");
      toggleModal();
      if (tabType === "completeOrder") {
        setValue(3);
        completedOrdersApi(sortByValue, searchVal, currentPage, filterModalValues);
      } else {
        setValue(6);
        allOrderListingApi(sortByValue, searchVal, currentPage, filterModalValues);
      }
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        if (response.message === "Please remove Abuse words") {
          setModalContent("Please remove abusive words");
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        }
        setModalLink("");
        toggleModal();
      }
    }
  };

  const callAcceptRejectAPi = async (id, action, type) => {
    let data = {
      orderId: id,
      rescheduleOrderStatus: action,
    };
    let response = await dispatch(acceptAndReject(data, token));
    if (response.status === "SUCCESS") {
      if (action === "ACCEPTED") {
        setValue(1);
        setOrderPageData(undefined);
        openOrderApi(sortByValue, searchVal, currentPage, filterModalValues);
      } else {
        if (type === "reschedule") {
          setValue(1);
          setOrderPageData(undefined);
          openOrderApi(sortByValue, searchVal, currentPage, filterModalValues);
        } else {
          setValue(4);
          setOrderPageData(undefined);
          canceledOrderListingApi(sortByValue, searchVal, currentPage, filterModalValues);
        }
      }
      setModalContent(response.message);
      setModalLink("");
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  };

  const repostAndScheduledOrderAPI = async (id, action) => {
    let data = {
      orderId: id,
      rescheduleOrderStatus: action,
    };

    let response = await dispatch(repostAndScheduledOrder(data, token));
    if (response.status === "SUCCESS") {
      setValue(4);
      setOrderPageData(undefined);
      canceledOrderListingApi(sortByValue, searchVal, currentPage, filterModalValues);

      setModalContent(response.message);
      setModalLink("");
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  };

  const cancelSellerBuyerOrderApi = async (id, action, props, comment) => {
    let requestDeliveryDate = "";
    let setbidTimeArr;
    let pickupStartTime = "";
    let pickupEndTimeArr;
    let pickupEndTime = "";

    if (props !== "") {
      requestDeliveryDate = moment(props.values.cancelDate).format(BIDFORMAT);
      setbidTimeArr = props.values.requestedStartTime.split(":");
      pickupStartTime = props.values.requestedStartTime;
      pickupEndTimeArr = props.values.requestedEndTime.split(":");
      pickupEndTime = props.values.requestedEndTime;

      if (pickupStartTime.length) {
        let setHours = setbidTimeArr[0];
        let setMinutes = setbidTimeArr[1];
        if (setbidTimeArr[0].length === 1) {
          setHours = 0 + setbidTimeArr[0];
        }
        if (setbidTimeArr[1].length === 1) {
          setMinutes = 0 + setbidTimeArr[1];
        }
        pickupStartTime = setHours + ":" + setMinutes;
      }

      if (pickupStartTime.length) {
        let setHours = pickupEndTimeArr[0];
        let setMinutes = pickupEndTimeArr[1];
        if (pickupEndTimeArr[0].length === 1) {
          setHours = 0 + pickupEndTimeArr[0];
        }
        if (pickupEndTimeArr[1].length === 1) {
          setMinutes = 0 + pickupEndTimeArr[1];
        }
        pickupEndTime = setHours + ":" + setMinutes;
      }
    }
    let data = {
      orderId: id,
      actionType: action,
      comment: comment,
      requestDeliveryDate: requestDeliveryDate,
      deliveryWindowBegin: pickupStartTime,
      deliveryWindowEnd: pickupEndTime,
    };
    let response = await dispatch(cancelSellerBuyerOrder(data, token));
    if (response.status === "SUCCESS") {
      if (action === "RESCHEDULE") {
        setValue(1);
        setOrderPageData(undefined);
        openOrderApi(sortByValue, searchVal, currentPage, filterModalValues);

        setModalContent(response.message);
        setModalLink("");
        toggleModal();
      } else {
        setValue(4);
        setOrderPageData(undefined);
        canceledOrderListingApi(sortByValue, searchVal, currentPage, filterModalValues);

        setModalContent(response.message);
        setModalLink("");
        toggleModal();
      }
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  };

  const orderBagageUpdateApi = async (orderType) => {
    let response = await dispatch(orderBagageUpdate(orderType, token));
    if (response.status === "SUCCESS") {
      orderBagageInfoApi();
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  };

  const orderHoldPaymentAPI = async (orderId, paymentMethodId, type) => {
    let data = {
      orderId: orderId,
      paymentMethodId: paymentMethodId,
    };
    let response = await dispatch(orderHoldPayment(data, token));
    if (response.status === "SUCCESS") {
      if (type === "AllOrder") {
        setValue(6);
        setOrderPageData(undefined);
        setCurrentPage(1);
        orderBagageInfoApi();
        allOrderListingApi(sortByValue, searchVal, currentPage, filterModalValues);
      } else {
        orderBagageUpdateApi("OPEN");
        setOrderPageData(undefined);
        setValue(1);
        setCurrentPage(1);
        openOrderApi(sortByValue, searchVal, currentPage, filterModalValues);
      }
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  };

  const renderPagination = (data) => (
    data && data.totalElements !== 0 && (
      <Pagination
        currentPage={currentPage}
        totalPage={data.totalElements}
        itemsCountPerPage={10}
        onPageChange={(value) => {
          let obj = {
            myOrderSelectedPage: value,
          }
          dispatch({ type: 'MYORDER_PAGINATION', payload: obj })
          onPageChange(value);
        }}
      />
    )
  );

  return (
    <section>
      <Container>
        <div className={classes.root}>
          <Breadcrumb
            breadcrumbArr={breadcrumbMapArr}
            selected={pageLanguageContents?.Breadcrumb[1]?.MyOrders}
            title=""
          />
          <SectionWrapper>
            <div className={styled.textSection}>
              <OrderTopHeader>
                <DropDown
                  name="dropDown"
                  data={sortByListValues}
                  searchDropDown={sortByValue}
                  placeholder={pageLanguageContents?.HeaderContents[0]?.SortBy}
                  onChangeHandler={(event) => {
                    setCurrentPage(1);
                    setSortByValue(event.value);
                    const tabValueTemp = value;
                    const fetchOrderData = (tabValue, sortValueTemp) => {
                      const apiMapping = { 0: pendingDeliveryRequestsApi, 1: openOrderApi, 2: deliveredOrderApi, 3: completedOrdersApi, 4: canceledOrderListingApi, 5: claimedOrderListingApi, 6: allOrderListingApi, };
                      const apiFunc = apiMapping[tabValue];
                      if (apiFunc) {
                        setOrderPageData(undefined);
                        apiFunc(sortValueTemp, searchVal, 1, filterModalValues);
                      }
                    };
                    fetchOrderData(tabValueTemp, event.value);
                  }}
                />
                <div style={{ display: 'flex' }}>
                  <SearchSection>
                    <SearchTypeahead
                      placeholder={pageLanguageContents?.HeaderContents[6]?.Search}
                      focusOnShow={false}
                      typeahead={typeahead}
                      filterBy="title"
                      defaulTitle={searchVal}
                      title=""
                      pageType=""
                      pageName="myOrder"
                      containerStyle="makeSearch"
                      color="#fff"
                      backgroundColor="#01b3ff"
                      callBack={(searchId) => {
                        setCurrentPage(1);
                        setSarchVal(searchId)
                        const tabValueTemp = value;
                        const fetchOrderData = (tabValue, searchId) => {
                          const apiMapping = { 0: pendingDeliveryRequestsApi, 1: openOrderApi, 2: deliveredOrderApi, 3: completedOrdersApi, 4: canceledOrderListingApi, 5: claimedOrderListingApi, 6: allOrderListingApi, };
                          const apiFunc = apiMapping[tabValue];
                          if (apiFunc) {
                            setOrderPageData(undefined);
                            apiFunc(sortByValue, searchId, 1, filterModalValues);
                          }
                        };
                        fetchOrderData(tabValueTemp, searchId);
                      }}
                    />
                  </SearchSection>
                  <FilterWrapper>
                    <img
                      src={FilterIcon}
                      alt=""
                      onClick={() => setFilterPopUpModal(true)}
                    />
                  </FilterWrapper>
                </div>
              </OrderTopHeader>
              <OrderTabDescription>
                <AppBar position="static" className={classes.AppBar}>
                  <Tabs
                    value={value}
                    onChange={handleTabChangeFunction}
                    aria-label="simple tabs example"
                    variant={"scrollable"}
                    scrollButtons={"on"}
                  >
                    {orderTabsList.map((tab, index) => (
                      <Tab
                        key={index}
                        className={(index === 0 && !storedData?.data?.isDeliveryPricingVendor) ? classes.hiddenTab : ''}
                        label={<>{tab.label} {tab?.count > 0 && <p className="notification">{tab?.count}</p>}</>}
                        {...a11yProps(index)}
                        onClick={() => handleTabClick(tab.type, index, tab.sortOrder)}
                      />
                    ))}
                  </Tabs>
                </AppBar>
                <TabPanel value={value} index={0}>
                  {deliveryTenderRequestsData && (
                    <DeliveryRequestsListDetails
                      pageData={deliveryTenderRequestsData?.pricingOrderList}
                      fetchDataCallBack={(type) => {
                        if (type === 'decline') pendingDeliveryRequestsApi(sortByValue, searchVal, currentPage, filterModalValues)
                      }}
                    />
                  )}
                </TabPanel>
                <TabPanel value={value} index={1}>
                  {orderPageData && (
                    <OrderBox
                      response={orderPageData}
                      orderType="openOrder"
                      deliveableFlag={value}
                      displayHoldBanner={displayHoldBanner}
                      displayHoldBannerFunc={displayHoldBannerFunc}
                      callBackFun={(id, status, document) => {
                        callUpdateStatus(id, status, document, 'fromPendingOrdersTab');
                      }}
                      openOrderCallBack={(orderId, paymentMethodId) => {
                        orderHoldPaymentAPI(
                          orderId,
                          paymentMethodId,
                          "OpenOrder"
                        );
                      }}
                      canceledOrderCallBack={(id) => {
                        canceledOrderApi(id);
                      }}
                      rescheduleCallBack={(id, action) => {
                        callAcceptRejectAPi(id, action, "reschedule");
                      }}
                      downloadCallBack={(id) => {
                        downloadOrderApi(id);
                      }}
                      modalCallBack={(id, action, props, comment) => {
                        if (action === "REJECTEDORDER") {
                          repostAndScheduledOrderAPI(id);
                        } else {
                          cancelSellerBuyerOrderApi(id, action, props, comment);
                        }
                      }}
                      retryPaymentCallBack={(id) => {
                        retryPayment(id);
                      }}
                    />
                  )}
                </TabPanel>
                <TabPanel value={value} index={2}>
                  {orderPageData && (
                    <OrderBox
                      response={orderPageData}
                      orderType="deliveredOrder"
                      deliveableFlag={value}
                      callBackFun={() => { }}
                      canceledOrderCallBack={(id) => {
                        canceledOrderApi(id);
                      }}
                      deliveredOrderCallBack={() => {
                        deliveredOrderApi(sortByValue, searchVal, currentPage, filterModalValues);
                      }}
                      downloadCallBack={(id) => {
                        downloadOrderApi(id);
                      }}
                      imageUpload={(imagePath) => {
                        imageUploadApi(imagePath);
                      }}
                      callBackTimmer={() => {
                        orderBagageUpdateApi("DELIVERED");
                        setOrderPageData(undefined);
                        orderBagageInfoApi();
                        setCurrentPage(1);
                        deliveredOrderApi(sortByValue, searchVal, 1, filterModalValues);
                      }}
                    />
                  )}
                </TabPanel>
                <TabPanel value={value} index={3}>
                  {orderPageData && (
                    <OrderBox
                      response={orderPageData}
                      orderType="completeOrder"
                      deliveableFlag={value}
                      callBackFun={(id, action, orderType) => {
                        if (action === "ACCEPTED" || orderType === "Cancel") {
                          repostAndScheduledOrderAPI(id, action);
                        }
                      }}
                      reviewRatingFun={(items, ratingValue, note) => {
                        ratingUpdateCompletedAPI(items, ratingValue, note, "completeOrder");
                      }}
                      canceledOrderCallBack={(id) => { }}
                      downloadCallBack={(id) => {
                        downloadOrderApi(id);
                      }}
                      imageUpload={(imagePath) => {
                        imageUploadApi(imagePath);
                      }}
                      callBackTimmer={() => { }}
                    />
                  )}
                </TabPanel>
                <TabPanel value={value} index={4}>
                  {orderPageData && (
                    <OrderBox
                      response={orderPageData}
                      orderType="cancelOrder"
                      deliveableFlag={value}
                      callBackFun={(id, action, orderType) => {
                      }}
                      canceledOrderCallBack={(id) => { }}
                      downloadCallBack={(id) => {
                        downloadOrderApi(id);
                      }}
                      callBackTimmer={() => { }}
                    />
                  )}
                </TabPanel>
                <TabPanel value={value} index={5}>
                  {orderPageData && (
                    <OrderBox
                      response={orderPageData}
                      orderType="claimOrder"
                      deliveableFlag={value}
                      callBackFun={(id, action, orderType) => {
                      }}
                      canceledOrderCallBack={(id) => { }}
                      downloadCallBack={(id) => { }}
                      callBackTimmer={() => { }}
                      imageUpload={(imagePath) => {
                        imageUploadApi(imagePath);
                      }}
                    />
                  )}
                </TabPanel>
                <TabPanel value={value} index={6}>
                  {orderPageData && (
                    <OrderBox
                      response={orderPageData}
                      orderType="allOrder"
                      deliveableFlag={value}
                      allOrderShipDeliverCallback={(id, status, document) => {
                        callUpdateStatus(id, status, document, 'fromAllOrdersTab');
                      }}
                      callBackFun={(id, status, ratingValue, note) => {
                        if (status === "Rating") {
                          // ratingUpdateAPI(id, status, ratingValue, note);
                        } else {
                          callDisputeApi(id);
                        }
                      }}
                      reviewRatingFun={(items, ratingValue, note) => {
                        ratingUpdateCompletedAPI(items, ratingValue, note, "allOrder");
                      }}

                      canceledOrderCallBack={(id) => { }}
                      openOrderCallBack={(orderId, paymentMethodId) => {
                        orderHoldPaymentAPI(
                          orderId,
                          paymentMethodId,
                          "AllOrder"
                        );
                      }}
                      imageUpload={(imagePath) => {
                        imageUploadApi(imagePath);
                      }}
                      downloadCallBack={(id) => {
                        downloadOrderApi(id);
                      }}
                      callBackTimmer={() => { }}
                      modalCallBack={(id, action, props, comment) => {
                        if (action === "REJECTEDORDER") {
                          repostAndScheduledOrderAPI(id);
                        } else {
                          cancelSellerBuyerOrderApi(id, action, props, comment);
                        }
                      }}
                    />
                  )}
                </TabPanel>
              </OrderTabDescription>
            </div>
          </SectionWrapper>
        </div>

        {renderPagination(orderPageData?.orders)}
        {renderPagination(deliveryTenderRequestsData)}
      </Container>

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=""
        content={modalContent}
        link={modalLink}
      />

      <FilterModal
        isOpen={filterPopUpModal}
        toggle={setFilterPopUpModal}
        fieldValues={filterModalValues}
        currentPage={value}
        closeModal={() => setFilterPopUpModal(false)}
        callBackFun={(values) => {
          setCurrentPage(1)
          setSarchVal('')
          setFilterModalValues(values)
          if (value === 0) pendingDeliveryRequestsApi(sortByValue, "", 1, values);
          if (value === 1) openOrderApi(sortByValue, "", 1, values);
          if (value === 2) deliveredOrderApi(sortByValue, "", 1, values);
          if (value === 3) completedOrdersApi(sortByValue, "", 1, values);
          if (value === 4) canceledOrderListingApi(sortByValue, "", 1, values);
          if (value === 5) claimedOrderListingApi(sortByValue, "", 1, values);
          if (value === 6) allOrderListingApi(sortByValue, "", 1, values);
          setFilterPopUpModal(false);
        }}
      />
    </section>
  );
}